import mediator from "@tvg/mediator";
import { get } from "lodash";
import { BaseEventProps, track } from "@tvg/amplitude";
import {
  EventData,
  TrackSelectorData,
  EventProps,
  MediatorEventType,
  ModuleEventProps
} from "./types";
import { EVENT_NAME, LABELS } from "./constants";
import { COMMON_EVENT_NAMES } from "../../constants";

export default () => {
  mediator.base.subscribe(MediatorEventType.NEXT_RACE, (data: EventData) =>
    track<EventProps>(EVENT_NAME.NEXT, {
      [BaseEventProps.EVENT_CATEGORY]: COMMON_EVENT_NAMES.SITE_CLICK,
      [BaseEventProps.EVENT_LABEL]: `${get(data, "payload.trackName")} - R${get(
        data,
        "payload.raceNumber"
      )}`,
      [BaseEventProps.MODULE]: "race_selector_arrow",
      [BaseEventProps.RACE_NUMBER]: get(data, "payload.raceNumber"),
      [BaseEventProps.TRACK_NAME]: get(data, "payload.trackName")
    })
  );

  mediator.base.subscribe(MediatorEventType.PREV_RACE, (data: EventData) =>
    track<EventProps>(EVENT_NAME.BACK, {
      [BaseEventProps.EVENT_CATEGORY]: COMMON_EVENT_NAMES.SITE_CLICK,
      [BaseEventProps.EVENT_LABEL]: `${get(data, "payload.trackName")} - R${get(
        data,
        "payload.raceNumber"
      )}`,
      [BaseEventProps.MODULE]: "race_selector_arrow",
      [BaseEventProps.RACE_NUMBER]: get(data, "payload.raceNumber"),
      [BaseEventProps.TRACK_NAME]: get(data, "payload.trackName")
    })
  );

  mediator.base.subscribe(MediatorEventType.PROMOS, () =>
    track<EventProps>(`${LABELS.PROMOS} ${EVENT_NAME.OPEN}`, {
      [BaseEventProps.EVENT_CATEGORY]: COMMON_EVENT_NAMES.SITE_CLICK,
      [BaseEventProps.EVENT_LABEL]: LABELS.PROMOS,
      [BaseEventProps.MODULE]: "race info header"
    })
  );

  mediator.base.subscribe(MediatorEventType.UPCOMING, () =>
    track<EventProps>(`${LABELS.PROGRAM_RACE} ${EVENT_NAME.OPEN}`, {
      [BaseEventProps.EVENT_CATEGORY]: COMMON_EVENT_NAMES.SITE_CLICK,
      [BaseEventProps.EVENT_LABEL]: "upcoming races",
      [BaseEventProps.MODULE]: "race info header"
    })
  );

  mediator.base.subscribe(MediatorEventType.BACK, (data: EventData) =>
    track<EventProps>(EVENT_NAME.NAVIGATED, {
      [BaseEventProps.EVENT_CATEGORY]: "navigation",
      [BaseEventProps.LINK_TEXT]: "back button",
      [BaseEventProps.MODULE]: "header",
      [BaseEventProps.LINK_URL]: get(data, "payload.destinationUrl")
    })
  );

  mediator.base.subscribe(MediatorEventType.WAGER_SCROLL, (data: EventData) =>
    track<EventProps>(EVENT_NAME.SCROLLED, {
      [BaseEventProps.EVENT_CATEGORY]: "bet selector",
      [BaseEventProps.EVENT_LABEL]: get(data, "payload.label", ""),
      [BaseEventProps.MODULE]: "bet_selector"
    })
  );

  mediator.base.subscribe(
    MediatorEventType.WAGER_TYPE_SELECT,
    (data: EventData) =>
      track<EventProps>(EVENT_NAME.SELECTED_BET, {
        [BaseEventProps.EVENT_CATEGORY]: "bet selector",
        [BaseEventProps.EVENT_LABEL]: `${get(data, "payload.label")}`,
        [BaseEventProps.MODULE]: "bet_selector",
        [BaseEventProps.RACE_NUMBER]: get(data, "payload.raceNumber"),
        [BaseEventProps.TRACK_NAME]: get(data, "payload.trackName")
      })
  );

  mediator.base.subscribe(MediatorEventType.TIP_MORE, (data: EventData) =>
    track<EventProps>(EVENT_NAME.SELECT, {
      [BaseEventProps.EVENT_CATEGORY]: COMMON_EVENT_NAMES.SITE_CLICK,
      [BaseEventProps.EVENT_LABEL]: "more",
      [BaseEventProps.MODULE]: "racing tips",
      [BaseEventProps.TAG]: `${get(data, "payload.trackName")} - R${get(
        data,
        "payload.raceNumber"
      )} - ${get(data, "payload.mtp")}`
    })
  );

  mediator.base.subscribe(MediatorEventType.CHANGE_RACE, (data: EventData) =>
    track<EventProps>(EVENT_NAME.NAVIGATED, {
      [BaseEventProps.EVENT_CATEGORY]: "Navigation",
      [BaseEventProps.LINK_TEXT]: data.payload.actionName,
      [BaseEventProps.MODULE]: data.payload.module,
      [BaseEventProps.LINK_URL]: data.payload.destinationUrl
    })
  );

  mediator.base.subscribe(
    MediatorEventType.TRACK_SELECTOR,
    (data: TrackSelectorData) =>
      track<EventProps>(EVENT_NAME.SELECTED_RACE_NUM, {
        [BaseEventProps.EVENT_CATEGORY]: "race selector",
        [BaseEventProps.EVENT_LABEL]: get(data, "payload.raceNumberSelected"),
        [BaseEventProps.MODULE]: "race_selector_dropdown",
        [BaseEventProps.RACE_NUMBER]: get(data, "payload.currentRaceNumber"),
        [BaseEventProps.TRACK_NAME]: get(data, "payload.trackName"),
        [ModuleEventProps.ITEM_SELECTED]: get(
          data,
          "payload.raceNumberSelected"
        )
      })
  );

  mediator.base.subscribe(
    MediatorEventType.RUNNER_SELECTION,
    (data: EventData) => {
      if (data.payload?.action?.toLowerCase().includes("add")) {
        track<EventProps>(EVENT_NAME.SELECTION_ADD, {
          [BaseEventProps.BET_TYPE]: get(data, "payload.betType"),
          [BaseEventProps.EVENT_CATEGORY]: "Bet",
          [ModuleEventProps.PLACE_TYPE]: get(data, "payload.label"),
          [BaseEventProps.MODULE]: "Race Card",
          [BaseEventProps.RACE_NUMBER_SELECTION]: get(
            data,
            "payload.race.raceNumber"
          ),
          [BaseEventProps.RACE_TRACK_SELECTION]: get(
            data,
            "payload.race.track.trackName"
          )
        });
      } else {
        track<EventProps>(EVENT_NAME.SELECTION_REMOVE, {
          [BaseEventProps.EVENT_CATEGORY]: "Bet",
          [BaseEventProps.EVENT_LABEL]: get(data, "payload.betType"),
          [BaseEventProps.MODULE]: "bet_ticket"
        });
      }
    }
  );

  mediator.base.subscribe(MediatorEventType.TOOLTIP_CLICK, () =>
    track<EventProps>(
      `${LABELS.PROGRAM_HANDICAPPING_TOOLTIP} ${EVENT_NAME.OPEN}`,
      {
        [BaseEventProps.EVENT_CATEGORY]: COMMON_EVENT_NAMES.SITE_CLICK,
        [BaseEventProps.EVENT_LABEL]: "Handicapping Tooltip",
        [BaseEventProps.MODULE]: "Race Card"
      }
    )
  );

  mediator.base.subscribe(
    MediatorEventType.DEPOSIT_CLICK,
    (data: { destinationURL: string }) =>
      track<EventProps>(EVENT_NAME.NAVIGATED, {
        [BaseEventProps.EVENT_CATEGORY]: "Navigation",
        [BaseEventProps.LINK_TEXT]: "Deposit Now",
        [BaseEventProps.MODULE]: "bet_ticket",
        [BaseEventProps.LINK_URL]: data.destinationURL
      })
  );
};
